export default __webpack_public_path__ + "static/media/3-5-1.5da9ab78.jpg";